import { FONT_SIZE_LIST } from 'components/account/const'

// Reader preferences share the apps' key names and live per browser.
export const readPreference = (key: string, fallback: boolean) => {
  try {
    const value = localStorage.getItem(key)
    return value === null ? fallback : value === '1'
  } catch {
    return fallback
  }
}

export const writePreference = (key: string, value: boolean) => {
  try {
    localStorage.setItem(key, value ? '1' : '0')
  } catch {
    /* private mode: the setting still works for this visit */
  }
}

const TEXT_SIZE_KEY = 'reader.textSize'

export type ReaderTextSize = (typeof FONT_SIZE_LIST)[number]

/** The text size picked in the reader settings, or null before one is picked. */
export const readTextSize = (): ReaderTextSize | null => {
  try {
    const label = localStorage.getItem(TEXT_SIZE_KEY)
    return FONT_SIZE_LIST.find((size) => size.label === label) || null
  } catch {
    return null
  }
}

export const writeTextSize = (size: ReaderTextSize) => {
  try {
    localStorage.setItem(TEXT_SIZE_KEY, size.label)
  } catch {
    /* private mode: the size still applies for this visit */
  }
}
